/** Dispatched when axios clears invalid JWT — AuthContext listens and syncs React state */
export const CLEAR_AUTH_EVENT = 'dwello:clear-auth';
